<template>
    <div class="container" id="serves">
        <div class="row serve">
            <div class="col-lg-5 imm">
                <img class="img-fluid" src="../assets/services-left-image.png" alt="">
            </div>
            <div class="col-lg-6 text-lg-start">
                <h5>
                    Grow Your Website With Our SEO <span class="one">Service</span> & <span class="two">Project</span>  Ideas
                </h5>
                <p>Space Dynamic HTML5 template is free to use for your website projects. However, you are not permitted to redistribute
                the template ZIP file on any CSS template collection websites. Please contact us for more information. Thank you for
                your kind cooperation.
                </p>
                <div  class="on text-start mb-4">
                    <h5>Website Analysis</h5>
                    <div class="progress" style="height:10px">
                        <div class="progress-bar" style="width:84%;height:10px"></div>
                    </div>
                </div>
                <div class="on text-start mb-4">
                    <h5>SEO Reports</h5>
                    <div class="progress" style="height:10px">
                        <div class="progress-bar" style="width:88%;height:10px"></div>
                    </div>
                </div>
                <div class="on text-start mb-4">
                    <h5>Page Optimizations</h5>
                    <div class="progress" style="height:10px">
                        <div class="progress-bar" style="width:90%;height:10px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    name: 'serve',
//     mounted(){
//         let u = document.getElementById("serves");
//         window.onscroll = function(){
//     // skills offset top
//     //اتجيب السكرول مالته
//     let skillsoffsettop = u.offsetTop;
//     // skills outer heihgt 
//     //تحسبلك الطول مال النعصر 
//     let skillsouterheight = u.offsetHeight;

//     // window height
//     //ايجيب الطول مال الويندو الي انت فاتحه
//     let windowheight = this.innerHeight;

//     // window secrolltop
//     //الجزء الي تسويلة سكرول  
//     let windowscrolltop = this.pageYOffset;

//     if(windowscrolltop > (skillsoffsettop + skillsouterheight - windowheight)){
//         let allskills = document.querySelectorAll(".nav-link");
//         allskills.forEach((skill) => {
//             // skill.classList.remove("active ");
//             skill.classList.remove("active")
//         })
//         allskills.forEach((sk)=>{
//             if(sk.classList.contains(`${u.id}`)){
//                 sk.classList.add("active")
//             }
//         })

//     }
// }
//     }
    
    }
</script>

<style  scoped>
.imm{
    margin-bottom: 100px;
}
.serve{
    margin-top: 150px;
}
.progress-bar{
    background: linear-gradient(105deg, rgba(255, 77, 30, 1) 0%, rgba(255, 44, 109, 1) 100%)
}
.on{
    margin:10px;
}
.on h5{
    font-weight: 600;
    font-size: 20px;
}
p{
    margin-bottom: 20px;
    line-height: 1.6;

}
h5{
    font-weight: 600;
    font-size: 30px;
    margin-bottom: 20px

}
.one{
    color: #03a4ed
}
.two{
    color:#fe3f40
}
</style>